var swiper__tabs = new Swiper("#swiper__tabs", {
	//slidesPerView: 1.15,
	freeMode: true,
	watchSlidesProgress: true,
	setWrapperSize: 960,
	width: 240,
    breakpoints: {
        768: {
            slidesPerView: 3,
			allowTouchMove: false,
			setWrapperSize: false,
			width: null,
		},
    }    	
});

var swiper__cards = new Swiper("#swiper__cards", {
	spaceBetween: 18,
	navigation: {
		nextEl: ".latam-estudiar-ingles-tabs-2023__swiper-wrapper-2 .swiper-button-next",
		prevEl: ".latam-estudiar-ingles-tabs-2023__swiper-wrapper-2 .swiper-button-prev",
	},
	thumbs: {
		swiper: swiper__tabs,
	},
	
});

